module.exports = __webpack_public_path__ + "img/arrow-right.cd1cedf2.svg";